<template>
  <div style="height: 100%">
    <v-row style="height: 100%" align="center" justify="center" class="mb-4">
      <v-col cols="12" md="5">
        <v-img max-height="250" contain src="@/assets/others/pageNotFound.svg" alt="Page not found - Image" />
        <div class="text-center" style="font-size: 50px; color: grey">
          Page Not Found
        </div>
        <div class="text-center" style="font-size: 15px; color: grey">
          We weren't able to find the page you were looking for.
        </div>
        <v-row justify="center" class="mt-4">
          <v-btn style="color: #2f3860" outlined rounded @click="sendHome()" id="page-not-found-button"
            >Go Back</v-btn
          >
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: `${this.$i18n.t("METAINFO.page_not_found.tab_title")}`,
    }
  },
  data: () => ({
    prevRoute: null,
  }),
  methods: {
    sendHome() {
      if (this.prevRoute !== null)
        this.$router.push(this.prevRoute.path).catch(() => {});
      else this.$router.push("/").catch(() => {});
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
};
</script>